import { render } from "./Platform.vue?vue&type=template&id=0925669a&scoped=true"
import script from "./Platform.vue?vue&type=script&lang=js"
export * from "./Platform.vue?vue&type=script&lang=js"

import "./Platform.vue?vue&type=style&index=0&id=0925669a&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0925669a"]])

export default __exports__